import React from 'react';
import { Colors } from '@/common/colors/colors';
import { DetailSection, DetailTitle } from '../../callAnalysis.styles';

const AnalysisSummary = ({ summary }) => {
	if (!summary) {
		return null;
	}

	return (
		<DetailSection>
			<DetailTitle>Summary</DetailTitle>
			<p style={{ color: Colors.darkBlue, margin: 0 }}>{summary}</p>
		</DetailSection>
	);
};

export default AnalysisSummary;
